import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      #container {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        pointer-events: none;\n        z-index: var(--wired-dialog-z-index, 100);\n      }\n      #container::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0,0,0,0.4);\n        opacity: 0;\n        transition: opacity 0.5s ease;\n      }\n      #overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        opacity: 0;\n        transform: translateY(150px);\n        transition: transform 0.5s ease, opacity 0.5s ease;\n      }\n      .layout.vertical {\n        display: -ms-flexbox;\n        display: -webkit-flex;\n        display: flex;\n        -ms-flex-direction: column;\n        -webkit-flex-direction: column;\n        flex-direction: column;\n      }\n      .flex {\n        -ms-flex: 1 1 0.000000001px;\n        -webkit-flex: 1;\n        flex: 1;\n        -webkit-flex-basis: 0.000000001px;\n        flex-basis: 0.000000001px;\n      }\n      wired-card {\n        display: inline-block;\n        background: white;\n        text-align: left;\n      }\n\n      :host([open]) #container {\n        pointer-events: auto;\n      }\n      :host([open]) #container::before {\n        opacity: 1;\n      }\n      :host([open]) #overlay {\n        opacity: 1;\n        transform: none;\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <div id=\"container\">\n      <div id=\"overlay\" class=\"vertical layout\">\n        <div class=\"flex\"></div>\n        <div style=\"text-align: center; padding: 5px;\">\n          <wired-card .elevation=\"", "\"><slot></slot></wired-card>\n        </div>\n        <div class=\"flex\"></div>\n      </div>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { customElement, property, css, html, LitElement, query } from 'lit-element';
import { WiredCard } from 'wired-card/lib/wired-card.js';
import 'wired-card/lib/wired-card.js';

var WiredDialog = /*#__PURE__*/function (_LitElement) {
  _inherits(WiredDialog, _LitElement);

  var _super = _createSuper(WiredDialog);

  function WiredDialog() {
    var _this;

    _classCallCheck(this, WiredDialog);

    _this = _super.apply(this, arguments);
    _this.elevation = 5;
    _this.open = false;
    return _this;
  }

  _createClass(WiredDialog, [{
    key: "render",
    value: function render() {
      return html(_templateObject(), this.elevation);
    }
  }, {
    key: "updated",
    value: function updated() {
      if (this.card) {
        this.card.wiredRender(true);
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return css(_templateObject2());
    }
  }]);

  return WiredDialog;
}(LitElement);

__decorate([property({
  type: Number
}), __metadata("design:type", Object)], WiredDialog.prototype, "elevation", void 0);

__decorate([property({
  type: Boolean,
  reflect: true
}), __metadata("design:type", Object)], WiredDialog.prototype, "open", void 0);

__decorate([query('wired-card'), __metadata("design:type", WiredCard)], WiredDialog.prototype, "card", void 0);

WiredDialog = __decorate([customElement('wired-dialog')], WiredDialog);
export { WiredDialog };